/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MFAAuditLogExport } from '../models/MFAAuditLogExport';
import type { MFAConfig } from '../models/MFAConfig';
import type { MFAConfigCreate } from '../models/MFAConfigCreate';
import type { MFAConfigUpdate } from '../models/MFAConfigUpdate';
import type { PaginatedMFAAuditLogList } from '../models/PaginatedMFAAuditLogList';
import type { PaginatedMFAConfigList } from '../models/PaginatedMFAConfigList';
import type { PaginatedMFALockoutList } from '../models/PaginatedMFALockoutList';
import type { PaginatedMFAUserList } from '../models/PaginatedMFAUserList';
import type { PatchedMFAConfigUpdate } from '../models/PatchedMFAConfigUpdate';
import type { ReturnSuccess } from '../models/ReturnSuccess';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MfaService {

  /**
   * @param createdAtFrom 
   * @param createdAtTo 
   * @param eventType 
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param search A search term.
   * @param user 
   * @returns PaginatedMFAAuditLogList 
   * @throws ApiError
   */
  public static mfaAuditLogsList(
createdAtFrom?: string,
createdAtTo?: string,
eventType?: string,
page?: number,
pageSize?: number,
search?: string,
user?: string,
): CancelablePromise<PaginatedMFAAuditLogList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/mfa/audit-logs/',
      query: {
        'created_at_from': createdAtFrom,
        'created_at_to': createdAtTo,
        'event_type': eventType,
        'page': page,
        'page_size': pageSize,
        'search': search,
        'user': user,
      },
    });
  }

  /**
   * @param requestBody 
   * @param createdAtFrom 
   * @param createdAtTo 
   * @param eventType 
   * @param user 
   * @returns ReturnSuccess 
   * @throws ApiError
   */
  public static mfaAuditLogsExportCreate(
requestBody: MFAAuditLogExport,
createdAtFrom?: string,
createdAtTo?: string,
eventType?: string,
user?: string,
): CancelablePromise<ReturnSuccess> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/mfa/audit-logs/export/',
      query: {
        'created_at_from': createdAtFrom,
        'created_at_to': createdAtTo,
        'event_type': eventType,
        'user': user,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param emailEnabled 
   * @param enabled 
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param preferredMethod 
   * @param search A search term.
   * @param user 
   * @returns PaginatedMFAConfigList 
   * @throws ApiError
   */
  public static mfaConfigsList(
emailEnabled?: string,
enabled?: string,
page?: number,
pageSize?: number,
preferredMethod?: string,
search?: string,
user?: string,
): CancelablePromise<PaginatedMFAConfigList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/mfa/configs/',
      query: {
        'email_enabled': emailEnabled,
        'enabled': enabled,
        'page': page,
        'page_size': pageSize,
        'preferred_method': preferredMethod,
        'search': search,
        'user': user,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns MFAConfigCreate 
   * @throws ApiError
   */
  public static mfaConfigsCreate(
requestBody: MFAConfigCreate,
): CancelablePromise<MFAConfigCreate> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/mfa/configs/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id A unique integer value identifying this Utilizator.
   * @returns MFAConfig 
   * @throws ApiError
   */
  public static mfaConfigsRetrieve(
id: number,
): CancelablePromise<MFAConfig> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/mfa/configs/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id A unique integer value identifying this Utilizator.
   * @param requestBody 
   * @returns MFAConfigUpdate 
   * @throws ApiError
   */
  public static mfaConfigsUpdate(
id: number,
requestBody?: MFAConfigUpdate,
): CancelablePromise<MFAConfigUpdate> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/mfa/configs/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id A unique integer value identifying this Utilizator.
   * @param requestBody 
   * @returns MFAConfigUpdate 
   * @throws ApiError
   */
  public static mfaConfigsPartialUpdate(
id: number,
requestBody?: PatchedMFAConfigUpdate,
): CancelablePromise<MFAConfigUpdate> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/mfa/configs/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param lockoutType 
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param search A search term.
   * @param user 
   * @returns PaginatedMFALockoutList 
   * @throws ApiError
   */
  public static mfaLockoutsList(
lockoutType?: string,
page?: number,
pageSize?: number,
search?: string,
user?: string,
): CancelablePromise<PaginatedMFALockoutList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/mfa/lockouts/',
      query: {
        'lockout_type': lockoutType,
        'page': page,
        'page_size': pageSize,
        'search': search,
        'user': user,
      },
    });
  }

  /**
   * @param id A unique integer value identifying this Utilizator.
   * @returns void 
   * @throws ApiError
   */
  public static mfaLockoutsDestroy(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/mfa/lockouts/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param mfaConfigEmailEnabled 
   * @param mfaConfigEnabled 
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param search A search term.
   * @returns PaginatedMFAUserList 
   * @throws ApiError
   */
  public static mfaUsersList(
mfaConfigEmailEnabled?: string,
mfaConfigEnabled?: string,
page?: number,
pageSize?: number,
search?: string,
): CancelablePromise<PaginatedMFAUserList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/mfa/users/',
      query: {
        'mfa_config_email_enabled': mfaConfigEmailEnabled,
        'mfa_config_enabled': mfaConfigEnabled,
        'page': page,
        'page_size': pageSize,
        'search': search,
      },
    });
  }

}
